var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "plus-progress_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 16 0)",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#plus-progress_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14.666a5.804 5.804 0 01-2.342-.475 6.1 6.1 0 01-1.9-1.284 6.1 6.1 0 01-1.283-1.9A5.805 5.805 0 012 8.666c0-.834.158-1.614.475-2.342a6.099 6.099 0 011.283-1.9 6.099 6.099 0 011.9-1.283A5.805 5.805 0 018 2.666h.1l-.567-.567a.61.61 0 01-.191-.467.68.68 0 01.667-.675.62.62 0 01.474.192L10.2 2.866a.64.64 0 01.2.466.64.64 0 01-.2.467L8.483 5.516a.62.62 0 01-.475.191.68.68 0 01-.666-.675.61.61 0 01.191-.466l.567-.567H8c-1.3 0-2.403.453-3.308 1.358-.906.906-1.359 2.009-1.359 3.309 0 1.3.453 2.402 1.359 3.308.905.906 2.008 1.358 3.308 1.358 1.3 0 2.403-.452 3.308-1.358.906-.905 1.359-2.008 1.359-3.308 0-.19.064-.348.191-.475a.645.645 0 01.475-.192c.19 0 .348.064.475.192a.645.645 0 01.192.475c0 .833-.158 1.614-.475 2.341a6.1 6.1 0 01-1.283 1.9 6.1 6.1 0 01-1.9 1.284A5.804 5.804 0 018 14.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.563 8.749l-.6-.144.217-1.921h2.13v.606H8.797l-.094.842c.05-.03.127-.061.23-.094.102-.035.217-.052.343-.052.184 0 .348.028.49.086.142.057.263.14.362.25.1.109.177.243.23.4a1.709 1.709 0 010 1.019 1.105 1.105 0 01-.635.685c-.161.067-.35.101-.569.101-.163 0-.321-.024-.474-.073a1.3 1.3 0 01-.409-.216 1.114 1.114 0 01-.289-.346 1.049 1.049 0 01-.112-.469h.745c.01.108.038.2.083.279a.489.489 0 00.185.177.552.552 0 00.268.062.51.51 0 00.245-.054.443.443 0 00.164-.151.712.712 0 00.091-.23 1.25 1.25 0 00.032-.286.994.994 0 00-.037-.279.595.595 0 00-.112-.216.496.496 0 00-.193-.14.672.672 0 00-.268-.05.66.66 0 00-.323.065.778.778 0 00-.187.149zM6.89 6.676v3.8h-.75V7.54l-.902.287v-.591l1.57-.56h.081z"
  }))));
}
export default SvgPlusProgress;